import React from "react";
import styled from "styled-components";

import GridView from "./GridView";

const ProductList = (props: any) => {
  const { filter, products } = props;
  if (products.length < 1) {
    return <Message>Sorry, there are no matching products.</Message>;
  }
  return <GridView products={products}>product list</GridView>;
};

const Message = styled.p`
  font-family: HelveticaNeue-Light;
  font-size: 20px;
  margin: 0.25rem 0;
`;

export default ProductList;
